import React from 'react';

import { Badge, BadgeVariant, Box, Flex, FlexProps, MantineSize, Text, Tooltip } from '@mantine/core';

interface ItemTagsViewProps extends FlexProps {
  tags?: string[];
  showedTagsCount?: number;
  maxChipWidth?: number;
  chipSize?: MantineSize;
}

export function ItemTagsView({
  tags,
  showedTagsCount = 2,
  maxChipWidth = 100,
  chipSize = 'sm',
  ...flexProps
}: ItemTagsViewProps) {
  if (!tags || tags.length === 0) return null;

  const displayedTags = tags.slice(0, showedTagsCount);

  const remainingTags = tags.slice(showedTagsCount);

  const TagBadge = ({ tag, badgeVariant }: { tag: string; badgeVariant: BadgeVariant }) => (
    <Badge
      color="gray.7"
      size={chipSize}
      mx={2}
      maw={maxChipWidth}
      style={{ border: '0.0625rem solid #dee2e6' }}
      variant={badgeVariant}>
      {tag}
    </Badge>
  );

  return (
    <Flex direction="row" align="center" {...flexProps}>
      {displayedTags.map((tag, index) => (
        <TagBadge key={index} tag={tag} badgeVariant="dot" />
      ))}
      {remainingTags.length > 0 && (
        <Tooltip
          maw={200}
          withinPortal
          label={remainingTags.map((tag, index) => (
            <React.Fragment key={index}>
              <Text my={7} p={0} truncate maw={200}>
                {tag}
              </Text>
            </React.Fragment>
          ))}
          position="top">
          <Box mb={3}>
            <TagBadge tag={'...'} badgeVariant="outline" />
          </Box>
        </Tooltip>
      )}
    </Flex>
  );
}
